<template>
  <div class="row">
    <div style="background-color: #E4F1E1" class="col-12 col-md-9 pt-3 mt-3 border border-success text-start">
        <font size="2">
            <p>このアプリはコーラス声の質を判定するプログラムです。
              試作中ですが、皆さん楽しんでみてください。<br>
              0.2秒ごとに「声の質」「男声・女声の区別」「音階」を判定し、
              リフレッシュすることを繰り返します。<br>
              アプリは下記論文をもとに山中駿・長谷川太一が作成しました。
              お問い合わせは<a href="https://sites.google.com/view/shigerushinomoto/" target="_blank">篠本 滋</a>までご連絡ください。<br>
              A. Yoshida and S. Shinomoto, Mechanical classification of voice quality.
              arXiv (2020) 2003.13033<br>
            </p>
        </font>
    </div>
    <div class="col-12 col-md-8 mt-1 mb-3">
      <font size="2">Version 1.1: 2023/05/05</font>
    </div>      
  </div>
</template>

<script>
export default {
  name: 'Tail'
}
</script>

<style>
</style>